import {Model} from "@/app/Model";
import {Utils} from "@/app/Utils";
import {ResponsabilitaData} from "@/app/data/ResponsabilitaData";
import {TestoResult} from "./data/TestoResult";
import {TestoData} from "@/app/data/TestoData";
import {ResponsabilitaAdminComms} from "@/app/admin/ResponsabilitaAdminComms";

import {Comms} from "@/app/Comms";

declare let frontendConfig: any;
declare let gtagO: Function;

export class CommsResponsabilita {

    public comms: Comms = Comms.getInstance();

    protected static instance: CommsResponsabilita;
    static listAllDone: boolean = false;

    public continueFunction: Function | null = null;

    protected inChiamataCitta: boolean = false;
    protected inChiamataGiudici: boolean = false;
    protected inChiamataDashboard: boolean = false;
    protected inChiamataPercorso: boolean = false;
    protected inChiamataDejure: boolean = false;

    public responsabilitaAdmin: ResponsabilitaAdminComms = ResponsabilitaAdminComms.getInstance();

    public static getInstance(): CommsResponsabilita {
        if (!CommsResponsabilita.instance) {
            CommsResponsabilita.instance = new CommsResponsabilita();
        }

        return CommsResponsabilita.instance;
    }

    public setup(): void {
        this.responsabilitaAdmin.commsResponsabilita = this;

        setTimeout( ()=> {
            Model.res_setupped = true;
        }, 1000)
    }
    
    //BUSINESS
    //setup lists
    public listAll(callback: Function | null = null): void {
        this.listCitta((e: IEsito) => {
            this.listGiudici((e: IEsito) => {
                CommsResponsabilita.listAllDone = true;

                setTimeout( ()=> {postMessage("listAllRefresh")}, 2000);

                if (callback) callback();
            })
        })
    }

    public listCitta(callback: Function | null = null): void {
        if (Comms.hf_isNotLogged()) {
            this.continueFunction = this.listCitta;
            setTimeout(function () {
                Comms.getInstance().doLoginByToken(callback);
            }, Comms.baseLoadTimeout);
            return;
        } else {
            this.continueFunction = null;
        }

        let model: Model = Model.getReactiveInstance();

        if (!this.inChiamataCitta) {
            this.inChiamataCitta = true;

            model.res_lista_citta = [];

            let commander: string = "res_listCitta";
            let endpoint: string = "/graphql";
            let payload = {
                query: `{
                    pgQuery(
                         input: {
                            name: "resp_lista_citta"
                            params: { }
                         }
                    ) {
                         list
                         record
                    }
                }`,
                variables: {},
                operationName: null,
            };
            let options = {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            };

            //@ts-ignore
            if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

            let errorCallback: Function = (): void => { };
            let innerCallback: Function = (esito: IEsito): void => {
                Utils.successAlert(esito);
                this.inChiamataCitta = false;
                if (esito.response && esito.response.data && esito.response.data.pgQuery && esito.response.data.pgQuery.list) {
                    model.res_lista_citta = esito.response.data.pgQuery.list;
                }
                if (callback) callback(esito);
            };

            this.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
        }
    }

    public listGiudici(callback: Function | null = null): void {
        if (Comms.hf_isNotLogged()) {
            this.continueFunction = this.listGiudici;
            setTimeout(function () {
                Comms.getInstance().doLoginByToken(callback);
            }, Comms.baseLoadTimeout);
            return;
        } else {
            this.continueFunction = null;
        }

        let model: Model = Model.getReactiveInstance();

        if (!this.inChiamataGiudici) {
            this.inChiamataGiudici = true;

            model.res_lista_giudici = [];

            let commander: string = "res_listGiudici";
            let endpoint: string = "/graphql";
            let payload = {
                query: `{
                    pgQuery(
                         input: {
                            name: "resp_lista_giudici"
                            params: { }
                         }
                    ) {
                         list
                         record
                    }
                }`,
                variables: {},
                operationName: null,
            };
            let options = {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            };

            //@ts-ignore
            if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

            let errorCallback: Function = (): void => { };
            let innerCallback: Function = (esito: IEsito): void => {
                Utils.successAlert(esito);
                this.inChiamataGiudici = false;
                if (esito.response && esito.response.data && esito.response.data.pgQuery && esito.response.data.pgQuery.list) {
                    model.res_lista_giudici = esito.response.data.pgQuery.list;
                }
                if (callback) callback(esito);
            };

            this.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
        }
    }

    //query dashboard
    public queryDashboard(callback: Function | null = null, soloPaginazione: boolean = false): void {
        if (Comms.hf_isNotLogged()) {
            this.continueFunction = this.queryDashboard;

            setTimeout(function () {
                Comms.getInstance().doLoginByToken(callback);
            }, Comms.baseLoadTimeout);
            return;
        } else {
            this.continueFunction = null;
        }

        let model: Model = Model.getReactiveInstance();

        if (!this.inChiamataDashboard) {
            this.inChiamataDashboard = true;

            if (!soloPaginazione) {
                model.res_get_dashboard = new ResponsabilitaData();
            }

            let commander: string = "queryDashboard";
            let endpoint: string = "/graphql";
            let innerParams: string = "";

            if (model.res_flow_dashboard.tipologia_danno != "" && model.res_flow_dashboard.tipologia_danno.toLowerCase() != "entrambi")  {
                innerParams += 'tipologia_danno:"' + model.res_flow_dashboard.tipologia_danno.replace(/'/g, "''") + '" ';
            }// else if (model.res_flow_dashboard.tipologia_danno.toLowerCase() === "entrambi") {
             //   innerParams += 'tipologia_danno:"' + Model.lista_tipologia_danno[0].replace(/'/g, "''") + ',' + Model.lista_tipologia_danno[1].replace(/'/g, "''") + '" ';
             //}
            if (model.res_flow_dashboard.tipologia_danno_patrimoniale != ""  && model.res_flow_dashboard.tipologia_danno_patrimoniale.toLowerCase() != "entrambi")  {
                innerParams += 'tipologia_danno_patrimoniale:"' + model.res_flow_dashboard.tipologia_danno_patrimoniale.replace(/'/g, "''") + '" ';
            }// else if (model.res_flow_dashboard.tipologia_danno_patrimoniale.toLowerCase() === "entrambi") {
             //   innerParams += 'tipologia_danno_patrimoniale:"' + Model.lista_tipologia_danno_patrimoniale[0].replace(/'/g, "''") + ',' + Model.lista_tipologia_danno_patrimoniale[1].replace(/'/g, "''") + '" ';
             //}
            if (model.res_flow_dashboard.tipologia_danno_non_patrimoniale != "" && model.res_flow_dashboard.tipologia_danno_non_patrimoniale.toLowerCase() != "tutti")  {
                innerParams += 'tipologia_danno_non_patrimoniale:"' + model.res_flow_dashboard.tipologia_danno_non_patrimoniale.replace(/'/g, "''") + '" ';
            }// else if (model.res_flow_dashboard.tipologia_danno_non_patrimoniale.toLowerCase() === "tutti") {
             //   innerParams += 'tipologia_danno_non_patrimoniale:"' + Model.lista_tipologia_danno_non_patrimoniale[0].replace(/'/g, "''") + ',' + Model.lista_tipologia_danno_non_patrimoniale[1].replace(/'/g, "''") +
             //       ',' +   Model.lista_tipologia_danno_non_patrimoniale[2].replace(/'/g, "''") + ',' + Model.lista_tipologia_danno_non_patrimoniale[3].replace(/'/g, "''") + '" ';
             //}

            if (model.res_flow_dashboard.domanda_accolta == "Si") {
                innerParams += 'domanda_accolta: true ';
            } else if (model.res_flow_dashboard.domanda_accolta == "No") {
                innerParams += 'domanda_accolta: false ';
            }
            if (model.res_flow_dashboard.risarcimento != "")  {
                innerParams += 'risarcimento:"' + model.res_flow_dashboard.risarcimento.replace(/'/g, "''") + '" ';
            }
            if (model.res_flow_dashboard.risarcimento_richiesto_active === true)  {
                innerParams += 'risarcimento_richiesto_da:' + model.res_flow_dashboard.risarcimento_richiesto_da + ' ';
                innerParams += 'risarcimento_richiesto_a:' + model.res_flow_dashboard.risarcimento_richiesto_a + ' ';
            }
            if (model.res_flow_dashboard.risarcimento_disposto_totale_active === true)  {
                innerParams += 'risarcimento_disposto_da:' + model.res_flow_dashboard.risarcimento_disposto_totale_da + ' ';
                innerParams += 'risarcimento_disposto_a:' + model.res_flow_dashboard.risarcimento_disposto_totale_a + ' ';
            }
            if (model.res_flow_dashboard.durata_procedimento_active)  {
                innerParams += 'durata_procedimento:' + model.res_flow_dashboard.durata_procedimento + ' ';
            }
            if (model.res_flow_dashboard.durata_procedimento_notNull === true) {
                innerParams += 'durata_procedimento_not_null: "true" ';
            } else {
                innerParams += 'durata_procedimento_not_null: "false" ';
            }
            if (model.res_flow_dashboard.riferimento_normativo != "" && model.res_flow_dashboard.riferimento_normativo != " ")  {
                innerParams += 'riferimento_normativo:["' + model.res_flow_dashboard.riferimento_normativo.replace(/'/g, "''") + '"] ';
            }

            if (model.res_flow_dashboard.id_localita != "")  {
                innerParams += 'id_localita:"' + model.res_flow_dashboard.id_localita.replace(/'/g, "''") + '" ';
            }
            if (model.res_flow_dashboard.giudice != "")  {
                innerParams += 'giudice:["' + model.res_flow_dashboard.giudice.replace(/'/g, "''") + '"] ';
            }
            if (model.res_flow_dashboard.data_active)  {
                let dataDa: Date = new Date(model.res_flow_dashboard.data_da + "-1-1");
                dataDa.setHours(0,0,0, 0);

                let dataA: Date = new Date(model.res_flow_dashboard.data_a + "-12-31");
                dataA.setHours(23,59,59, 999);

                let dataDaIso: string = dataDa.toISOString();
                let dataDaIsoSpl: string[] = dataDaIso.split("T");
                let dataAIso: string = dataA.toISOString();
                let dataAIsoSpl: string[] = dataAIso.split("T");

                innerParams += 'data_da:"' + dataDaIsoSpl[0] + '" ';
                innerParams += 'data_a:"' + dataAIsoSpl[0] + '" ';
            }

            if (model.res_flow_dashboard.paginazione_start > 0) {
                innerParams += 'start:' + Math.floor(model.res_flow_dashboard.paginazione_start * model.res_flow_dashboard.paginazione_rows).toFixed(0) + ' ';
            }

            let params: string = `{ ${innerParams} }`;

            let payload = {
                query: `{
                  pgQuery(
                     input: {
                        name: "civ_responsabilita_get_dashboard"
                        params: ${params}
                     }
                  ) {
                     list
                  }
               }`,
                variables: {},
                operationName: null,
            };

            let options = {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            };

            //@ts-ignore
            if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

            let errorCallback: Function = (): void => { };

            let innerCallback: Function = (esito: IEsito): void => {
                Utils.successAlert(esito);
                this.inChiamataDashboard = false;

                if (soloPaginazione) {
                    let useJson: any = esito.response.data.pgQuery.list[0].result;

                    if (useJson["sentenze_paginate"]) {
                        model.res_get_dashboard.sentenze_paginate = useJson["sentenze_paginate"]; //aggiorno solo dati relativi a paginazione in model.res_get_dashboard
                    }
                    if (useJson["sentenze_paginate_jump"]) {
                        model.res_get_dashboard.sentenze_paginate_jump = useJson["sentenze_paginate_jump"];
                        model.res_get_dashboard.sentenze_paginate_jump_display = model.res_get_dashboard.sentenze_paginate_jump.slice(0, model.res_flow_dashboard.diritto_paginazione_rows);
                    }
                    model.res_flow_dashboard.diritto_paginazione_start = 0;
                    model.res_flow_dashboard.diritto_paginazione_tot = model.res_get_dashboard.sentenze_paginate_jump.length;
                    model.res_flow_dashboard.diritto_paginazione_pages = Math.ceil(model.res_flow_dashboard.diritto_paginazione_tot / model.res_flow_dashboard.diritto_paginazione_rows) -1;
                } else {
                    model.res_get_dashboard = new ResponsabilitaData(esito.response);
                }

                // gtagO({
                //     'event': 'ricerca',
                //     'tipoRicerca': 'ricerca generale responsabilita',
                //     'testoCercato': JSON.stringify(payload),
                //     'risultati': model.res_get_dashboard.totale_numero_sentenze.valore
                // });

                if (callback) callback(esito);
            };

            this.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
        }
    }
    public queryPercorso(callback: Function | null = null, soloPaginazione: boolean = false): void {
        if (Comms.hf_isNotLogged()) {
            this.continueFunction = this.queryPercorso;

            setTimeout(function () {
                Comms.getInstance().doLoginByToken(callback);
            }, Comms.baseLoadTimeout);
            return;
        } else {
            this.continueFunction = null;
        }

        let model: Model = Model.getReactiveInstance();

        if (!this.inChiamataPercorso) {
            this.inChiamataPercorso = true;

            if (!soloPaginazione) {
                model.res_get_percorso = new ResponsabilitaData();
            }

            let commander: string = "queryPercorso";
            let endpoint: string = "/graphql";
            let innerParams: string = "";
            let innerGrafici: number[] = [];

            if (model.res_flow_percorso.tipologia_danno != "" && model.res_flow_percorso.tipologia_danno.toLowerCase() != "entrambi")  {
                innerParams += 'tipologia_danno:"' + model.res_flow_percorso.tipologia_danno.replace(/'/g, "''") + '" ';
            }// else if (model.res_flow_percorso.tipologia_danno.toLowerCase() === "entrambi") {
             //   innerParams += 'tipologia_danno:"' + Model.lista_tipologia_danno[0].replace(/'/g, "''") + ',' + Model.lista_tipologia_danno[1].replace(/'/g, "''") + '" ';
             //}
            if (model.res_flow_percorso.tipologia_danno_patrimoniale != ""  && model.res_flow_percorso.tipologia_danno_patrimoniale.toLowerCase() != "entrambi")  {
                innerParams += 'tipologia_danno_patrimoniale:"' + model.res_flow_percorso.tipologia_danno_patrimoniale.replace(/'/g, "''") + '" ';
            }// else if (model.res_flow_percorso.tipologia_danno_patrimoniale.toLowerCase() === "entrambi") {
             //   innerParams += 'tipologia_danno_patrimoniale:"' + Model.lista_tipologia_danno_patrimoniale[0].replace(/'/g, "''") + ',' + Model.lista_tipologia_danno_patrimoniale[1].replace(/'/g, "''") + '" ';
             //}
            if (model.res_flow_percorso.tipologia_danno_non_patrimoniale != "" && model.res_flow_percorso.tipologia_danno_non_patrimoniale.toLowerCase() != "tutti")  {
                innerParams += 'tipologia_danno_non_patrimoniale:"' + model.res_flow_percorso.tipologia_danno_non_patrimoniale.replace(/'/g, "''") + '" ';
            }// else if (model.res_flow_percorso.tipologia_danno_non_patrimoniale.toLowerCase() === "tutti") {
             //   innerParams += 'tipologia_danno_non_patrimoniale:"' + Model.lista_tipologia_danno_non_patrimoniale[0].replace(/'/g, "''") + ',' + Model.lista_tipologia_danno_non_patrimoniale[1].replace(/'/g, "''") +
             //       ',' +   Model.lista_tipologia_danno_non_patrimoniale[2].replace(/'/g, "''") + ',' + Model.lista_tipologia_danno_non_patrimoniale[3].replace(/'/g, "''") + '" ';
             //}

            innerGrafici.push(3);
            innerGrafici.push(4);
            innerGrafici.push(5);

            if (model.res_flow_percorso.domanda_accolta == "Si") {
                innerParams += 'domanda_accolta: true ';
            } else if (model.res_flow_percorso.domanda_accolta == "No") {
                innerParams += 'domanda_accolta: false ';
            }

            innerGrafici.push(8);
            if (model.res_flow_percorso.risarcimento != "")  {
                innerParams += 'risarcimento:"' + model.res_flow_percorso.risarcimento.replace(/'/g, "''") + '" ';
            }

            innerGrafici.push(9);

            if (model.res_flow_percorso.valori) {
                innerGrafici.push(6);
                innerGrafici.push(7);

                if (model.res_flow_percorso.risarcimento_richiesto_active === true)  {
                    innerParams += 'risarcimento_richiesto_da:' + model.res_flow_percorso.risarcimento_richiesto_da + ' ';
                    innerParams += 'risarcimento_richiesto_a:' + model.res_flow_percorso.risarcimento_richiesto_a + ' ';
                }
                if (model.res_flow_percorso.risarcimento_disposto_totale_active === true)  {
                    innerParams += 'risarcimento_disposto_da:' + model.res_flow_percorso.risarcimento_disposto_totale_da + ' ';
                    innerParams += 'risarcimento_disposto_a:' + model.res_flow_percorso.risarcimento_disposto_totale_a + ' ';
                }
            }

            if (model.res_flow_percorso.paginazione_start > 0) {
                innerParams += 'start:' + Math.floor(model.res_flow_percorso.paginazione_start * model.res_flow_percorso.paginazione_rows).toFixed(0) + ' ';
            }

            innerParams += 'durata_procedimento_not_null: "false" ';

            if (innerGrafici.length > 0) {
                if (innerGrafici.indexOf(1)<0) {
                    innerGrafici.push(1);
                }
                if (innerGrafici.indexOf(13)<0) {
                    innerGrafici.push(13);
                }
                innerParams += 'grafico:[' + innerGrafici.join(",") + ']';
            }
            let params: string = `{ ${innerParams} }`;

            let payload = {
                query: `{
                  pgQuery(
                     input: {
                        name: "civ_responsabilita_get_dashboard"
                        params: ${params}
                     }
                  ) {
                     list
                  }
               }`,
                variables: {},
                operationName: null,
            };

            let options = {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            };

            //@ts-ignore
            if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

            let errorCallback: Function = (): void => { };

            let innerCallback: Function = (esito: IEsito): void => {
                Utils.successAlert(esito);
                this.inChiamataPercorso = false;

                if (esito.response.errors && esito.response.errors.length > 0) {
                    alert("ERRORE DEL SERVER NELLA RICERCA PERCORSO.\nSiete pregati di riprovare piu tardi.\n\n"+esito.response.errors[0].message);
                    console.log("ERROR", esito.response.errors[0].message);
                }

                if (soloPaginazione) {
                    let useJson: any = esito.response.data.pgQuery.list[0].result;

                    if (useJson["sentenze_paginate"]) {
                        model.res_get_percorso.sentenze_paginate = useJson["sentenze_paginate"]; //aggiorno solo dati relativi a paginazione in model.res_get_percorso
                    }
                    if (useJson["sentenze_paginate_jump"]) {
                        model.res_get_percorso.sentenze_paginate_jump = useJson["sentenze_paginate_jump"];
                        model.res_get_percorso.sentenze_paginate_jump_display = model.res_get_percorso.sentenze_paginate_jump.slice(0, model.res_flow_percorso.diritto_paginazione_rows);
                    }
                    model.res_flow_percorso.diritto_paginazione_start = 0;
                    model.res_flow_percorso.diritto_paginazione_tot = model.res_get_percorso.sentenze_paginate_jump.length;
                    model.res_flow_percorso.diritto_paginazione_pages = Math.ceil(model.res_flow_percorso.diritto_paginazione_tot / model.res_flow_percorso.diritto_paginazione_rows) -1;
                } else {
                    model.res_get_percorso = new ResponsabilitaData(esito.response);
                }

                // gtagO({
                //     'event': 'ricerca', 
                //     'tipoRicerca': 'ricerca generale responsabilita',
                //     'testoCercato': JSON.stringify(payload), 
                //     'risultati': model.res_get_percorso.totale_numero_sentenze.valore
                // });

                if (callback) callback(esito);
            };

            this.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
        }
    }

    //dejure
    public callDejure(ids: number[] = [], callback?: Function): void {
        let model: Model = Model.getReactiveInstance();
        let token: string = model.returnedToken; //"AQIC5wM2LY4SfcwohGWOA30RUQd7mHXhPtUXF3XcvqjHseI.*AAJTSQACMDEAAlNLABM4MTgyNTM1NDgxMDk4MDM3NDgyAAJTMQAA*";

        let urlDejureSave: string = frontendConfig.urlDejureSave; //"https://gflapi-pre.giuffre.it/api/ModuloStrategia";
        let databankDejureSave: number = frontendConfig.databankDejureSave; //2;
        let urlDejureOpen: string = frontendConfig.urlDejureOpen+token; // "https://dejure-pre.giuffre.it/#/home?moduloStrategia=true&ticket="+token;
        
        let that: CommsResponsabilita = this;
        
        if (!this.inChiamataDejure && ids.length > 0) {
            this.inChiamataDejure = true;
            let options = {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    "Token": token,
                    "IdDatabank": databankDejureSave,
                    "IdDocMasterList": ids
                }),
            };
            
            fetch(urlDejureSave, options)
                .then((res: Response) => {
                    that.inChiamataDejure = false;
                    if (res.ok) {
                        return res.json();
                    } else {
                        if (callback) callback();
                        alert("ERRORE IN APERTURA DEJURE")
                    }
                })
                .then((response) => {
                    that.inChiamataDejure = false;
                    
                    if (response != undefined && response != null) {
                        // gtagO({event: 'outboundlink', url: urlDejureOpen})

                        window.open( urlDejureOpen, "_blank");
                    } else {
                        alert("ERRORE DI SALVATAGGIO SU DEJURE")
                    }
                    if (callback) callback();
                    //alla fine
                })
                .catch((err) => {
                    that.inChiamataDejure = false;
                    if (callback) callback();
                    alert("ERRORE IN CHIAMATA DEJURE")
                });
        } else {
            if (callback) callback();
        }
    }
    public openDettaglioDejure(id_doc_master: number = -1, id_databanks: number = -1, id: string = ""): void {
        let model: Model = Model.getReactiveInstance();
        let detailUrl: string = frontendConfig.urlDejureDetail.replace('{{id_doc_master}}', id_doc_master).replace('{{id}}', id).replace('{{id_databanks}}', id_databanks);
        detailUrl += model.returnedToken;
        
        // gtagO({event: 'outboundlink', url: detailUrl})

        window.open(detailUrl, "_blank");
    }
    public openDettaglioModal(id_doc_master: number = -1, id_databanks: number = -1, id: string = ""): void {
        let model: Model = Model.getReactiveInstance();
        model.testo_result = new TestoResult();
        model.testo_data = new TestoData();
        model.testo_data.id_doc_master = id_doc_master; //popolare altri parametri di model.testo_data ? tipo_testo = 2;   id_unita_doc =  0; tipo_ud = 0;

        //apre modale
        document.getElementById("triggerModalDettaglio")?.click();
        //chiamata
        this.queryGetTesto( () => {} );
    }

    //query testo dettaglio
    public queryGetTesto(callback: Function | null = null): void {
        if (Comms.hf_isNotLogged()) {
            this.continueFunction = this.queryGetTesto;

            setTimeout(function () {
                Comms.getInstance().doLoginByToken(callback);
            }, Comms.baseLoadTimeout);

            return;
        } else {
            this.continueFunction = null;
        }

        let model: Model = Model.getReactiveInstance();
        model.testo_result = new TestoResult();

        if (model.testo_data.id_doc_master) {
            let commander: string = "queryGetTesto";
            let endpoint: string = "/graphql";
            let innerParams: string = "";

            innerParams += 'id_doc_master:' + model.testo_data.id_doc_master + ' ';
            
            if (model.testo_data.tipo_testo)  {
                innerParams += 'tipo_testo:' + model.testo_data.tipo_testo + ' ';
            }
            if (model.testo_data.id_unita_doc)  {
                innerParams += 'id_unita_doc:' + model.testo_data.id_unita_doc + ' ';
            }
            if (model.testo_data.tipo_ud)  {
                innerParams += 'tipo_ud:' + model.testo_data.tipo_ud + ' ';
            }

            let params: string = `{ ${innerParams} }`;
            let payload = {
                query: `{
                  pgQuery(
                     input: {
                        name: "api_get_testo"
                        params: ${params}
                     }
                  ) {
                     list
                  }
               }`,
                variables: {},
                operationName: null,
            };

            let options = {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            };
            //@ts-ignore
            if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

            let errorCallback: Function = (): void => { };

            let innerCallback: Function = (esito: IEsito): void => {
                Utils.successAlert(esito);

                model.testo_result = new TestoResult(esito.response);

                gtagO({ 'event': 'getTesto', 'testoCercato': JSON.stringify(payload)});

                if (callback) callback(esito);
            };
            
            this.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
        }
    }

    //sintetizza
    public openSintesi(page: string, id: number, params: ISintesiParams): void {
        let urlSintesi: string = frontendConfig.urlSintesi.replace('{{idDocMaster}}', params.id_doc_master.toString()).replace('{{username}}', params.username).replace('{{crmid}}', params.crmid);
        //console.log("SINTETIZZO CON AI", page, id, params, urlSintesi);
        // Trova la riga di riferimento
        const referenceRow: HTMLElement | null = document.getElementById('docRiga-'+page+'-'+id);
        let newRowId: string = 'docRiga2-'+page+'-'+id;
        const referenceRow2: HTMLElement | null = document.getElementById(newRowId);
        if (!referenceRow2) {
            if (referenceRow) {
                const newRow = document.createElement('tr');
                newRow.id = newRowId;
                const newCell = document.createElement('td');
                newCell.colSpan = 3;
                newCell.classList.add("rigaSintetizza");
                newCell.innerHTML = `<div class="accordion" id="accordion-${page}-${id}">
                    <div class="accordion-item">
                        <h2 class="accordion-header">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-${page}-${id}" aria-expanded="true" aria-controls="collapse-${page}-${id}">
                            SINTESI
                        </button>
                        </h2>
                        <div id="collapse-${page}-${id}" class="accordion-collapse collapse show" data-bs-parent="#accordion-${page}-${id}">
                        <div class="accordion-body">
                            <iframe src="${urlSintesi}" class="iframeSintetizza"></iframe>
                        </div>
                        </div>
                    </div>
                    </div>`;


                // Aggiungi le celle alla nuova riga
                newRow.appendChild(newCell);

                // Inserisci la nuova riga subito dopo la riga di riferimento
                if (referenceRow.parentNode) {
                    referenceRow.parentNode.insertBefore(newRow, referenceRow.nextSibling);
                } else {
                    erroreFun()
                }

            } else {
                erroreFun()
            }
        }

        function erroreFun(): void {
            console.error(`Errore nella sintesi della riga ${id}`);
        }
    }
}

export interface IEsito {
    isOk: boolean;
    commander: string;
    response: any
}
export interface ISintesiParams {
    id_doc_master: number;
    username: string;
    crmid: string;
}